export default __webpack_public_path__ + "static/media/question.bdd288da.jpeg";